declare namespace $ {

	type $mol_string__value_shm_hitalama_map_widget_float_entity_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity['title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_entity_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_entity_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_entity_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity['field_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_entity_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_entity_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_entity_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_entity['table_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_entity_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_entity extends $shm_hitalama_map_widget_float_layout_vert {
		schema_widgets_auto( ): any
		Entity_name( ): $mol_string
		record_count_title( ): string
		Record_count( ): $mol_view
		Add_field_icon( ): $mol_icon_plus
		field_add( next?: any ): any
		Add_field( ): $mol_button_minor
		Open_table_icon( ): $mol_icon_table
		table_open( next?: any ): any
		Open_table( ): $mol_button_minor
		Entity_head( ): $mol_view
		padding_top( ): number
		padding_bottom( ): number
		padding_left( ): number
		padding_right( ): number
		gap( ): number
		add_types( ): readonly(any)[]
		auto( ): readonly(any)[]
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=entity.view.tree.d.ts.map